import { useEffect } from 'react';

import { subscribeToSolutionDeleted } from '../stores/utils/solution-sync-channel';
import {
  sendProStudioEvent,
  useProStudioCtxSelector,
} from '../xstate/app.xstate';

/**
 * PSTUDIO-3671: same-browser fast path. When a sibling tab deletes a solution
 * it broadcasts `solution-deleted`; if THIS tab has that same solution open
 * (matching projectId + botName), eject immediately (toast + redirect) via the
 * machine's `#solutionNotFound` — no reload required. Cross-machine is handled
 * by the backend-anchored detection in the load flow.
 */
export function useSolutionDeletedSync(): void {
  const projectId = useProStudioCtxSelector((ctx) => ctx.project?.id);
  const botName = useProStudioCtxSelector((ctx) => ctx.botName);

  useEffect(() => {
    const unsubscribe = subscribeToSolutionDeleted((msg) => {
      if (!botName || !projectId) return;
      if (msg.projectId === projectId && msg.botName === botName) {
        sendProStudioEvent({ type: 'solutionNotFound' });
      }
    });
    return unsubscribe;
  }, [projectId, botName]);
}
